import { FC, ReactNode } from 'react';
import { matchPath } from 'react-router';
import AnalyticsPageSkeleton from './AnalyticsPageSkeleton';
import AutomationsPageSkeleton from './AutomationsPageSkeleton';
import DashboardPageSkeleton from './DashboardPageSkeleton';
import InboxPageSkeleton from './InboxPageSkeleton';
import LegacyDashboardPageSkeleton from './LegacyDashboardPageSkeleton';
import ListPageSkeleton from './ListPageSkeleton';
import PipelinePageSkeleton from './PipelinePageSkeleton';
import SchedulePageSkeleton from './SchedulePageSkeleton';

type SkeletonVariant =
  | 'list'
  | 'dashboard'
  | 'legacyDashboard'
  | 'analytics'
  | 'schedule'
  | 'pipeline'
  | 'inbox'
  | 'automations';

const variantMap: Record<SkeletonVariant, FC> = {
  list: ListPageSkeleton,
  dashboard: DashboardPageSkeleton,
  legacyDashboard: LegacyDashboardPageSkeleton,
  analytics: AnalyticsPageSkeleton,
  schedule: SchedulePageSkeleton,
  pipeline: PipelinePageSkeleton,
  inbox: InboxPageSkeleton,
  automations: AutomationsPageSkeleton,
};

const routes: Array<{
  pattern: string;
  variant: SkeletonVariant;
  exact?: boolean;
}> = [
  { pattern: '/deals', variant: 'list' },
  { pattern: '/invoices', variant: 'list' },
  { pattern: '/customers', variant: 'list' },
  { pattern: '/tasks', variant: 'list' },
  { pattern: '/items', variant: 'list' },
  { pattern: '/materials', variant: 'list' },
  { pattern: '/suppliers', variant: 'list' },
  { pattern: '/timelogs', variant: 'list' },
  { pattern: '/service-plans', variant: 'list' },
  { pattern: '/automations', variant: 'automations' },
  { pattern: '/dashboard', variant: 'legacyDashboard' },
  { pattern: '/dashboard-new', variant: 'dashboard' },
  { pattern: '/analytics', variant: 'analytics', exact: false },
  { pattern: '/schedule', variant: 'schedule' },
  { pattern: '/pipelines/:pipelineId', variant: 'pipeline' },
  { pattern: '/inbox', variant: 'inbox', exact: false },
];

export const getSkeletonContentForPath = (
  pathname: string
): ReactNode | undefined => {
  const match = routes.find(({ pattern, exact = true }) =>
    matchPath(pathname, { path: pattern, exact })
  );
  if (!match) return undefined;
  const Component = variantMap[match.variant];
  return <Component />;
};
